import { useState } from 'react';
import { IconButton, Box, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import PushPinIcon from '@mui/icons-material/PushPin';

interface WidgetEditOverlayProps {
  children: React.ReactNode;
  editing: boolean;
  canEdit?: boolean;
  canPin?: boolean;
  onRemove: () => void;
  onEdit?: () => void;
  onPin?: () => void;
}

export function WidgetEditOverlay({ children, editing, canEdit, canPin, onRemove, onEdit, onPin }: WidgetEditOverlayProps) {
  const [hovered, setHovered] = useState(false);
  const showPin = editing && canPin && onPin && hovered;

  return (
    <Box
      sx={{ position: 'relative', height: '100%' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      {editing && (
        <>
          {showPin && (
            <Tooltip title="Pin to Home">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onPin();
                }}
                sx={{
                  position: 'absolute',
                  top: 4,
                  right: canEdit && onEdit ? 60 : 32,
                  zIndex: 10,
                  bgcolor: 'info.main',
                  color: 'white',
                  width: 24,
                  height: 24,
                  '&:hover': { bgcolor: 'info.dark' },
                }}
              >
                <PushPinIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          )}
          {canEdit && onEdit && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
              sx={{
                position: 'absolute',
                top: 4,
                right: 32,
                zIndex: 10,
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                width: 24,
                height: 24,
                '&:hover': { bgcolor: 'primary.dark' },
              }}
            >
              <SettingsIcon sx={{ fontSize: 16 }} />
            </IconButton>
          )}
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              zIndex: 10,
              bgcolor: 'error.main',
              color: 'white',
              width: 24,
              height: 24,
              '&:hover': { bgcolor: 'error.dark' },
            }}
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </>
      )}
    </Box>
  );
}
